// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, styled } from "@3778.care/goban";

import { Message, TeamMember1 } from "./icons";

const StyledBox = styled(Box)(() => ({
  height: "42px",
  position: "relative",
  width: "45px",
}));

const StyledTeamMember1 = styled(TeamMember1)(() => ({
  height: "30px",
  left: "0",
  position: "absolute",
  top: "0",
  width: "30px",
}));

const StyledMessage = styled(Message)(() => ({
  bottom: "0",
  position: "absolute",
  right: "0",
  width: "30px",
}));

export const FastContactHomeIcon = () => {
  return (
    <StyledBox>
      <StyledTeamMember1 />
      <StyledMessage />
    </StyledBox>
  );
};
